export default __webpack_public_path__ + "static/media/meter_no_needle.10ae2439.webp";